module.exports = __webpack_public_path__ + "static/yt_4@2x-901402f4e77c5d629b6907e7fb2a94a0.jpg";